module.exports = __webpack_public_path__ + "img/search-ats.897e06e4.svg";